import { render, staticRenderFns } from "./createTest.vue?vue&type=template&id=3bde8dfe&scoped=true&"
import script from "./createTest.vue?vue&type=script&lang=js&"
export * from "./createTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bde8dfe",
  null
  
)

export default component.exports